<div class="certification-detail" *ngIf="isTranslationLoaded">
  <!-- Breadcrumb Navigation and header-->
  <div class="breadcrumb-container">
    <app-certification-header
      [teamOptions]="teamOptions"
      [selectedTeams]="selectedTeams"
      [isLoadingTeams]="isLoadingTeams"
      [accountUuid]="accountUuid || ''"
      [moduleAssignmentUuid]="certificationId || ''"
      (teamChange)="onTeamChange($event)"
    >
    </app-certification-header>
  </div>
</div>

<div class="certification-detail-content-wrapper">
  <qai-inner-wrap>
    <div class="certification-detail-content">
      <!-- Statistics -->
      <app-certification-statistics 
        [engagementStats]="individualAssignmentEngagementStats"
        [isLoadingEngagementStats]="isLoadingEngagementStats">
      </app-certification-statistics>
      <app-certfication-highlight-cards></app-certfication-highlight-cards>
      <!-- Simulations -->
      <app-certification-simulations
        [assignmentId]="certificationId"
        [selectedTeamIds]="selectedTeams"
        [assignmentName]="certificationTitle"
        [engagementStatus]="certificationStatus"
      ></app-certification-simulations>
      <!-- Users — hidden when Hide_Individual_User_Data flag is on -->
      @if (!hideIndividualUserData) {
        <div #certificationUsersSection>
          <app-certification-users
            [isUserModalOpen]="isUserModalVisible"
            (expandUserModal)="openUserModal()"
            (closeUserModal)="closeUserModal()"
            [certificationStatus]="certificationStatus"
            [moduleAssignmentUuid]="certificationId || ''"
            [teamUuids]="selectedTeams"
            [userData]="userCertificationData"
            [isLoadingData]="isLoadingUsers"
            [assignmentName]="certificationTitle"
          >
          </app-certification-users>
        </div>
      }
      <!-- Attempts — hidden when Hide_Individual_User_Data flag is on -->
      @if (!hideIndividualUserData) {
        <app-certification-attempts [selectedTeams]="selectedTeams"
          [assignmentName]="certificationTitle">
        </app-certification-attempts>
      }
    </div>
  </qai-inner-wrap>
</div>

@if (!hideIndividualUserData) {
  <app-certification-assignment-user-modal
    [openUserModal]="isUserModalVisible"
    (closeUserModal)="closeUserModal()"
    [openUserModal]="isUserModalVisible"
    [moduleAssignmentUuid]="certificationId || ''"
    [teamUuids]="selectedTeams"
    [certificationStatus]="certificationStatus"
    [userData]="userCertificationData"
    [isLoadingData]="isLoadingUsers"
    (closeUserModal)="closeUserModal()"
    [assignmentName]="certificationTitle"
  ></app-certification-assignment-user-modal>
}
